import {
  isChatbotApiInbox,
  isConciergeApiInbox,
  isVoiceApiInbox,
} from './apiChannelSubtype';

// Otello al lavoro su una inbox API (chatbot, concierge o voice). Il gateway
// chatbot e il servizio voice segnalano l'attivita' con lo stesso
// toggle_typing_status degli operatori, quindi in store arriva un record di
// typing intestato al proprietario del token API dell'account. La dashboard
// non ragiona sull'identita' di quell'utente: su una inbox gestita qualunque
// record di typing vuol dire "Otello sta lavorando". I canali si distinguono
// con lo stesso discriminante della sidebar
// (additional_attributes.channel_subtype, vedi apiChannelSubtype.js): una
// inbox API con un sottotipo sconosciuto non e' nessuno di loro e resta sul
// typing normale.
// Il concierge passa dallo stesso gateway del chatbot ed e' una chat scritta:
// mostra lo stesso "sta rispondendo".
const OTELLO_TYPING_KIND = Object.freeze({
  ON_CALL: 'on_call',
  REPLYING: 'replying',
});

const resolveOtelloTypingKind = ({
  inbox = null,
  typingUsersList = [],
} = {}) => {
  if (!Array.isArray(typingUsersList) || typingUsersList.length === 0) {
    return null;
  }

  if (isVoiceApiInbox(inbox)) return OTELLO_TYPING_KIND.ON_CALL;
  if (isChatbotApiInbox(inbox) || isConciergeApiInbox(inbox)) {
    return OTELLO_TYPING_KIND.REPLYING;
  }
  return null;
};

// Le etichette arrivano gia' tradotte dal componente (stessa convenzione di
// resolveDisplayContactName): qui si sceglie solo quale mostrare.
const resolveOtelloTypingLabel = ({
  inbox = null,
  onCallLabel = '',
  replyingLabel = '',
  typingUsersList = [],
} = {}) => {
  const kind = resolveOtelloTypingKind({ inbox, typingUsersList });

  if (kind === OTELLO_TYPING_KIND.ON_CALL) return onCallLabel || '';
  if (kind === OTELLO_TYPING_KIND.REPLYING) return replyingLabel || '';
  return '';
};

export {
  OTELLO_TYPING_KIND,
  resolveOtelloTypingKind,
  resolveOtelloTypingLabel,
};
